function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from 'react';
import PropTypes from 'prop-types';
import { ensureMap } from '../hocs/ensureMap';
var MapEvent = /*#__PURE__*/function (_React$Component) {
  function MapEvent() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _defineProperty(_this, "handleClick", function (evt) {
      if (_this.props.onMapClick) _this.props.onMapClick(evt);
    });
    _defineProperty(_this, "handleSingleClick", function (evt) {
      if (_this.props.onMapSingleClick) _this.props.onMapSingleClick(evt);
    });
    return _this;
  }
  _inheritsLoose(MapEvent, _React$Component);
  var _proto = MapEvent.prototype;
  _proto.componentDidMount = function componentDidMount() {
    var map = this.props.map;
    map.on('click', this.handleClick);
    map.on('singleclick', this.handleSingleClick);
  };
  _proto.componentWillUnmount = function componentWillUnmount() {
    var map = this.props.map;
    map.un('click', this.handleClick);
    map.un('singleclick', this.handleSingleClick);
  };
  _proto.render = function render() {
    return null;
  };
  return MapEvent;
}(React.Component);
MapEvent.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * A function that takes an module:ol/MapBrowserEvent and returns a {boolean}.
   *
   * @param {ol/MapBrowserEvent} event Event from ol/Map click event.
   * @returns {boolean} if the event is a click event
   */
  onMapClick: PropTypes.func,
  /**
   * A function that takes an module:ol/MapBrowserEvent and returns a {boolean}.
   *
   * @param {ol/MapBrowserEvent} event Event from ol/Map singleclick event.
   * @returns {boolean} if the event is a map singleclick event
   */
  onMapSingleClick: PropTypes.func,
  /**
   * @ignore
   */
  map: PropTypes.object
} : {};
export default ensureMap(MapEvent);